import { useEffect, useState } from "react";
import { GetStaff } from "../../../services/OiService";
import { useAnalysisOrder } from "../redux/ReduxContext";

export default function AnalysisOrderStaff() {
    const { state, dispatch } = useAnalysisOrder();
    const [availableStaff, setAvailableStaff] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState("");
    const [filteredStaff, setFilteredStaff] = useState<string[]>([]);

    useEffect(() => {
        const fetchStaff = async () => {
            try {
                const staffData = await GetStaff();
                setAvailableStaff(staffData || []);
            } catch (error) {
                console.error("Failed to fetch staff:", error);
                setAvailableStaff([]);
            }
        };
        fetchStaff();
    }, []);

    const handleAddNewStaffMember = () => {
        const trimmedStaff = inputValue.trim();
        if (trimmedStaff && !state.taggedStaff.includes(trimmedStaff)) {
            dispatch({ type: 'ADD_ARRAY_ITEM', payload: { field: 'taggedStaff', item: trimmedStaff } });
            if (!availableStaff.includes(trimmedStaff)) {
                setAvailableStaff(prev => [...prev, trimmedStaff]);
            }
            setInputValue("");
        }
    };

    return (
        <div className="bg-white dark:bg-oi-dark-background p-4 mb-4 drop-shadow-md dark:drop-shadow-none text-primary-dark dark:text-primary-light">
            <h6 className="mb-2 text-sm font-bold">Tag staff</h6>
            <div className="my-4 relative">
                <div className="relative flex-1">
                    <input
                        type="text"
                        list="analysis-staff-options"
                        placeholder="Name"
                        value={inputValue}
                        onChange={(e) => {
                            setInputValue(e.target.value);
                            setFilteredStaff(e.target.value.trim().length > 1 ? availableStaff.filter(staff => staff.toLowerCase().includes(e.target.value.toLowerCase())) : []);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleAddNewStaffMember();
                            }
                        }}
                        className="h-12 w-full p-2 text-sm focus:outline-none focus:ring-2 focus:ring-oi-button-blue border bg-primary-light dark:bg-oi-dark-background border-primary-dark/70 dark:border-primary-light/50 text-primary-dark dark:text-oi-powder-form-yellow placeholder-gray-400 dark:placeholder-gray-300"
                    />
                    <datalist id="analysis-staff-options">
                        {filteredStaff.map((staff, index) => <option key={index} value={staff} />)}
                    </datalist>
                    <button className="absolute right-2 top-1/2 -translate-y-1/2 px-3 py-1 bg-oi-button-blue text-primary-light h-8" onClick={handleAddNewStaffMember}>Add</button>
                </div>
            </div>
            {state.taggedStaff.length > 0 && (
                <div className="mb-4">
                    <div className="flex flex-wrap gap-2">
                        {state.taggedStaff.map((staff, index) => (
                            <label key={index} className="flex items-center gap-2 cursor-pointer hover:bg-primary-dark/10 dark:hover:bg-primary-light/10 p-2 rounded transition-colors">
                                <input
                                    type="checkbox"
                                    checked={state.taggedStaff.includes(staff)}
                                    onChange={() => dispatch({ type: 'DELETE_ARRAY_ITEM', payload: { field: 'taggedStaff', index: state.taggedStaff.findIndex(s => s === staff) } })}
                                    className="w-4 h-4"
                                />
                                <span className="text-sm text-primary-dark dark:text-primary-light select-none">{staff}</span>
                            </label>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
